export enum eSetting {
  InboundUnitByUnit = 1,
  InboundAllowTwoUserSameLPN = 2,
  ValidateCarrierExists = 3,
  PrintCourierLabel = 4,
  PrintInternalLabel = 5,
  RelocateCommentary = 6,
  PreferRepositionOnPicking = 7,
  PrioritizeZoneWithLeastQuantity = 8,
  MandatoryLPNOnPicking = 9,
  ScanPositionOnPicking = 10,
  AutoAssignPackingPosition = 11,
  RecallMaxQtyItemOnPicking = 12,
  MultiBrandPicking = 13,
  ValidateRouteWithoutProductScanning = 14,
  BlockValidationOnPendingRelatedRoutes = 15,
  WorkOrderInheritsOrderTag = 16,
  AllowMultipleOrdersPerWorkOrder = 17,
  PrioritizeWorkOrdersForInternalStorage = 18,
  AutoCreatePickingRouteForExternalStorage = 19,
  PrioritizeByBrandAndCourierForExternalStorage = 20
}
